export default "__VITE_ASSET__bd6a2a05__"